import { Component, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Store } from '@ngrx/store';

import * as fromRoot from '../../app/store/reducers/index';
import { Auth } from '../interfaces/auth';
import * as AuthActions from '../store/auth.actions';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  standalone: false
})
export class SignupComponent implements OnDestroy   {

  constructor(public store: Store<fromRoot.IState>) { }

  public onSignup(form: NgForm) {
    const authData: Auth = new Auth(form.value.userName, form.value.password);
    this.store.dispatch(new AuthActions.TrySignup({ authData }));
  }

  public ngOnDestroy(): void {
    // No manual unsubscribe needed when using takeUntilDestroyed
  }
}
